/* eslint-disable react/static-property-placement */
import React, { Component, Fragment } from 'react';
import propTypes from 'prop-types';
import FontFaceObserver from 'fontfaceobserver';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { isMobile as isMobileDevice } from 'react-device-detect';
import cx from 'classnames';
import Layout from '../Layout/Layout';
import NavigationBar from '../NavigationBar/NavigationBar';
import NotFound from '../../NotFoundPage';
import Spinner from '../../common/Spinner/Spinner';
import { getTrackingPage } from '../../../actions/asyncActions';
import {
  getFontNameFromGoogleFontUrl,
} from '../../../helpers/fonts';
import styles from './TrackingPage.scss';
import { Preview } from '../../../constants/trackingPageVersions';
import LogoNew from '../../../icons/SortedLogoNew.svg';

class TrackingPage extends Component {
  static propTypes = {
    loaders: propTypes.shape({
      getTrackingPage: propTypes.bool,
    }),
    trackingPageData: propTypes.shape({
      font: propTypes.object,
      navigationBar: propTypes.object,
    }),
    actions: propTypes.shape({
      getTrackingPage: propTypes.func.isRequired,
    }),
    isPreviewOrHasData: propTypes.bool,
    version: propTypes.string,
    hideToolbar: propTypes.bool,
    forceMobile: propTypes.bool,
    isPreview: propTypes.bool,
    showPoweredByFooter: propTypes.bool,
  };

  static defaultProps = {
    loaders: {
      getTrackingPage: false,
    },
    trackingPageData: {},
    isPreviewOrHasData: false,
    actions: {
      getTrackingPage: () => { },
    },
    version: Preview,
    hideToolbar: false,
    forceMobile: false,
    isPreview: false,
    showPoweredByFooter: null,
  };

  constructor(props) {
    super(props);
    this.state = {
      uploadedTrackingPageFont: null,
      forceMobile: false,
    };
  }

  componentDidMount() {
    const {
      shipmentId,
      customerId,
      trackingPageName,
      trackingReference,
      customReference,
      metadataKey,
      metadataValue,
      version,
      isPreview,
    } = this.props;
    this.props.actions.getTrackingPage(
      trackingPageName,
      shipmentId,
      customerId,
      version,
      isPreview,
      trackingReference,
      customReference,
      metadataKey,
      metadataValue,
    );
  }

  componentDidUpdate(prevProps) {
    const { trackingPageData: { font } } = this.props;
    if (font !== prevProps.trackingPageData.font && font.url) {
      const trackingPageFont = new FontFaceObserver(getFontNameFromGoogleFontUrl(font.url));
      trackingPageFont.load(null, 6000).then((loadedFont) => (
        this.setState({
          uploadedTrackingPageFont: loadedFont,
        })));
    }
  }

  getFontLinks = () => {
    const { trackingPageData } = this.props;
    const links = [];
    // Always add a favicon link to prevent browsers from showing the cached favicon
    links.push({
      rel: 'shortcut icon',
      href: trackingPageData.base64FavIcon
        ? `data:image/x-icon;base64,${trackingPageData.base64FavIcon}`
        : 'data:image/x-icon;base64,',
    });
    if (trackingPageData.font) {
      links.push({
        href: trackingPageData.font.url,
        rel: 'stylesheet',

      });
    }
    if (trackingPageData.navigationBar?.font) {
      links.push({
        href: trackingPageData.navigationBar.font.url,
        rel: 'stylesheet',
      });
    }

    return links;
  };

  isTrackingPageOrNavigationBarFontUrlExisted = () => {
    const { trackingPageData: { font, navigationBar } } = this.props;
    const isTrackingPageFontUrlExisted = font && font.url;
    const isNavigationBarFontUrlExisted = navigationBar.font && navigationBar.font.url;
    return !!isTrackingPageFontUrlExisted || !!isNavigationBarFontUrlExisted;
  };

  render() {
    const {
      trackingPageData: {
        title, navigationBar, layouts, font,
      },
      isPreviewOrHasData,
      requestFailed,
      loaders,
      isPreview,
      hideToolbar,
      forceMobile: forceMobileParam,
      showPoweredByFooter,
    } = this.props;
    const {
      uploadedTrackingPageFont,
      forceMobile: forceMobileBtn,
    } = this.state;
    const forceMobile = forceMobileParam || forceMobileBtn;
    if (loaders.getTrackingPage) return <Spinner />;

    if (requestFailed) {
      return <div>An unknown error has occurred</div>;
    }

    const showNavBar = title && navigationBar;
    if (!showNavBar && !isPreviewOrHasData) {
      return <NotFound />;
    }

    return (
      <>
        <Helmet
          title={title}
          link={this.getFontLinks()}
        />
        <div className={cx(styles.trackingPageContainer, isPreview && forceMobile ? 'mobileMode' : 'desktopMode')}>
          {isPreview && !isMobileDevice && (
            <div className={styles.previewButtons}>
              <button
                type="button"
                className={!forceMobile ? styles.active : null}
                onClick={() => this.setState({ forceMobile: false })}
              >
                Desktop
              </button>
              <button
                type="button"
                className={forceMobile ? styles.active : null}
                onClick={() => this.setState({ forceMobile: true })}
              >
                Mobile
              </button>
            </div>
          )}
          {!hideToolbar && navigationBar && (
            <NavigationBar
              isFontExisted={this.isTrackingPageOrNavigationBarFontUrlExisted()}
              trackingPageFont={{ trackingPageFontProperties: font, uploadedTrackingPageFont }}
              navigationBar={navigationBar}
            />
          )}
          {isPreviewOrHasData && layouts
            ? (
              <Layout
                isTrackingPageFontExisted={!!font}
                layouts={layouts}
                uploadedTrackingPageFont={uploadedTrackingPageFont}
                isMobileViewport={isMobileDevice || forceMobile}
              />
            )
            : <NotFound />}
        </div>
        {showPoweredByFooter && (
        <footer className={styles.poweredBy}>
          <div className={styles.footerTitle}>Powered by</div>
          <LogoNew className={styles.poweredByLogo} />
        </footer>
        )}
      </>

    );
  }
}

const mapStateToProps = ({
  trackingPage: {
    trackingPageData,
    trackingDataExists,
    requestFailed,
    isPreview,
    showPoweredByFooter,
  },
  ui: { loaders },
}) => ({
  trackingPageData,
  showPoweredByFooter,
  isPreviewOrHasData: isPreview || trackingDataExists,
  requestFailed,
  loaders,
});

const mapDispatchToProps = (dispatch) => {
  const actions = {
    getTrackingPage,
  };
  return {
    actions: bindActionCreators(actions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TrackingPage);
